import React from 'react';
import { Redirect, Route, useHistory, useLocation } from 'react-router-dom';

import { connect } from 'react-redux';
import Layout from '../components/shared/layout/Layout';
// import { useHelpChat } from "../hooks/useHelpChat";
import { checkRoles } from '../helpers/roles.helper';
import useHotjar from '../hooks/useHotjar';

const StudentRoute = (props) => {
    const {
        layout = 'common',
        isAuthenticated,
        blockedRoles,
        permissionRoles,
        user,
        blockedStatus,
        title = false,
        component: Component,
        ...rest
    } = props;
    const finantial_status = blockedStatus;

    // Hooks
    useHotjar();
    const history = useHistory();

    const { pathname } = useLocation();
    const urlRedirect = pathname.slice(1);

    // FUNCTION
    const renderLayout = (layout, Component) => {
        const cases = {
            common: (
                <Layout finantial_status={finantial_status} layout={layout}>
                    {Component}
                </Layout>
            ),
        };

        return cases[layout] || cases['common'];
    };

    if (checkRoles(blockedRoles) && !checkRoles(permissionRoles)) {
        history.push('not-found');
    }

    // RETURN
    return (
        <Route
            {...rest}
            component={(props) =>
                isAuthenticated ? (
                    renderLayout(layout, <Component {...props} />)
                ) : (
                    <Redirect
                        to={
                            urlRedirect === 'not-found' ||
                            urlRedirect === 'logout' ||
                            urlRedirect === 'cookies'
                                ? '/auth'
                                : `/auth?redirect=${urlRedirect}`
                        }
                    />
                )
            }
        />
    );
};

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.auth.user,
    user: state.auth.user,
    blockedStatus: state.userStatus.blockedStatus,
});

export default connect(mapStateToProps)(StudentRoute);
